import { render, staticRenderFns } from "./TrancheDetails.vue?vue&type=template&id=68c2980b&scoped=true&"
import script from "./TrancheDetails.vue?vue&type=script&lang=js&"
export * from "./TrancheDetails.vue?vue&type=script&lang=js&"
import style0 from "./TrancheDetails.vue?vue&type=style&index=0&id=68c2980b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2980b",
  null
  
)

export default component.exports